import sparklineChart from 'britecharts/dist/umd/sparkline.min';
import {select} from 'd3-selection';
import {validateConfiguration, validateContainer} from '../helpers/validation';
import {applyConfiguration} from '../helpers/configuration';

import { line as sparklineLoadingState } from 'britecharts/dist/umd/loading.min';

const sparkline = {};

sparkline.create = (el, data, configuration = {}) => {
    const container = select(el);
    const chart = sparklineChart();

    validateContainer(container);
    validateConfiguration(chart, configuration);

    // Calls the chart with the container and dataset
    container.datum(data).call(applyConfiguration(chart, configuration));

    return chart;
};

sparkline.update = (el, data, configuration = {}, chart) => {
    const container = select(el);

    validateContainer(container);
    validateConfiguration(chart, configuration);
    applyConfiguration(chart, configuration);

    // Calls the chart with the container and dataset
    if (data && data.length) {
        container.datum(data).call(chart);
    } else {
        container.call(chart);
    }

    return chart;
};

sparkline.destroy = () => {};

sparkline.loading = () => sparklineLoadingState;

export default sparkline;
